module.exports = __webpack_public_path__ + "static/media/microsoft_office_excel_logo3.b5c72120.png";